export default "__VITE_ASSET__CaYKy8Tp__"